import script from "./PriceUpdatePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceUpdatePreview.vue?vue&type=script&setup=true&lang=ts"

import "./PriceUpdatePreview.vue?vue&type=style&index=0&id=37caaa90&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1078960470/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37caaa90"]])

export default __exports__